import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class UserPreferencesService {
  private baseUrl = "/api/userPreferences";

  constructor(private http: HttpClient) {}

  getPreference(key: string): Observable<string | null> {
    return this.http.get<string | null>(`${this.baseUrl}/${key}`).pipe(catchError(() => of(null)));
  }

  savePreference(key: string, value: string): Observable<void> {
    return this.http
      .post<void>(`${this.baseUrl}/${key}`, { value })
      .pipe(catchError(() => of(undefined as void)));
  }
}
